// extracted by mini-css-extract-plugin
export default {"bill_info_card":"bill_bill_info_card__tHfcs","card_content_label":"bill_card_content_label__CuLCG"};